import React from "react";
import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ServiceProViderTab from "./ServiceProViderTab";
// import { makeGetRequest } from "../../../utils/utils";
// import swal from "sweetalert";


function DetailsViewOfServicePro() {
  // const navigate = useNavigate();
  const { sid } = useParams();
 

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">
              {/* <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/AddServiceProvider")}
              /> */}
            </h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="serviceProViderViewMain">
                <div className="serviceProViderViewInner">
                  <div className="residentContMain">
                    <ServiceProViderTab name={sid} />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      </>
  );
}

export default DetailsViewOfServicePro;
